/*
 * LUMOS scroll-scale effect.
 * As an image scrolls toward the vertical center of the viewport it grows
 * slightly; as it moves away again (in either direction) it eases back to
 * its normal size. Applied to the hero, teaser, gallery and collection-grid
 * images. Disabled entirely for prefers-reduced-motion.
 */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var SELECTOR = '.lumos-hero__slide, .lumos-teaser__image, .lumos-gallery__slide img, .lumos-cgrid__item img';
  var MAX_SCALE = 1.06;

  var active = new Set();
  var ticking = false;

  function setScale(img, value) {
    img.style.setProperty('--lumos-scale', value);
  }

  function update() {
    ticking = false;
    var vh = window.innerHeight;
    var vCenter = vh / 2;

    active.forEach(function (img) {
      var rect = img.getBoundingClientRect();
      if (!rect.height) return;
      var imgCenter = rect.top + rect.height / 2;
      var maxDist = vh / 2 + rect.height / 2;
      var dist = Math.abs(imgCenter - vCenter);
      var t = maxDist > 0 ? 1 - Math.min(dist / maxDist, 1) : 0;
      var scale = 1 + (MAX_SCALE - 1) * t;
      setScale(img, scale.toFixed(4));
    });
  }

  function requestUpdate() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(update);
  }

  function init() {
    var images = document.querySelectorAll(SELECTOR);
    if (!images.length) return;

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              active.add(entry.target);
            } else {
              active.delete(entry.target);
              setScale(entry.target, 1);
            }
          });
          requestUpdate();
        },
        { rootMargin: '15% 0px' }
      );

      images.forEach(function (img) {
        observer.observe(img);
      });
    } else {
      images.forEach(function (img) {
        active.add(img);
      });
    }

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
    requestUpdate();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
